<template>
    <div>
        <Collapse
            v-if="apiKeys.length > 0"
            :active-key="activeKey"
        >
            <CollapsePanel
                v-for="(key, index) of apiKeys"
                :key="index.toString()"
            >
                <div
                    slot="header"
                    class="flex justify-between"
                >
                    {{ key.label || key.key }}
                    <Tag
                        :color="key.active ? 'green' : 'red'"
                        class="m-0"
                    >
                        {{ $t(key.active ? 'enabled' : 'disabled') }}
                    </Tag>
                </div>
                <div class="flex items-center justify-between mb-3">
                    <TextField
                        v-model="key.label"
                        class="w-4/5"
                        :placeholder="$t('label')"
                        style="margin-bottom: 0!important"
                    />
                    <AntSwitch v-model="key.active" />
                </div>
                <div class="flex items-center justify-between">
                    <ApiKey :api-key="key.key" />
                    <Tooltip
                        placement="bottom"
                        :title="$t('lastUsedAtDate', { date: $formatDateTime(key.lastUsedAt) })"
                    >
                        {{ key.lastUsedAt | from }}
                    </tooltip>
                </div>
            </CollapsePanel>
        </Collapse>
        <Empty
            v-else
            :description="$t('thisCustomerHasNoApiKeysYet')"
        >
            <AntButton
                type="primary"
                @click="$emit('add')"
            >
                {{ $t('generateAnApiKey') }}
            </AntButton>
        </Empty>
    </div>
</template>

<script>
import ApiKey from '@/components/customers/ApiKey.vue';
import TextField from '@/components/forms/elements/TextField.vue';
import { Collapse, Empty, Button, Tag, Switch, Tooltip } from 'ant-design-vue';
export default {
    name: 'ApiKeysCollapse',
    components: {
        Collapse,
        CollapsePanel: Collapse.Panel,
        AntButton: Button,
        Empty,
        Tag,
        AntSwitch: Switch,
        TextField,
        Tooltip,
        ApiKey,
    },
    props: {
        apiKeys: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        activeKey: null,
    }),
    watch: {
        apiKeys() {
            this.activeKey = (this.apiKeys.length - 1).toString();
        },
    },
};
</script>

<style>

</style>